/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Order_By_LabelInputs */



/**
* | output |
* | --- |
* | "Order By" |
*
* @param {Merge_Event_Group_Order_By_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_order_by_label = /** @type {((inputs?: Merge_Event_Group_Order_By_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Order_By_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trier par")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sortieren nach")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ordina per")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сортировать по")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ordenar por")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("排序方式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("並べ替え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("द्वारा आदेश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ordenar por")
	return /** @type {LocalizedString} */ ("Order By")
});